import test from './test.json';
import findData from './findData.json';
import menuTab from './menutab.json';
import pagination from './pagination.json';
import breadcrumbs from './breadcrumbs.json';

export default { test, findData, menuTab, pagination, breadcrumbs };
